import { Component, inject } from '@angular/core';
import { WaveService } from '@core/services/wave.service';

@Component({
  selector: 'app-wave-background',
  imports: [],
  templateUrl: './wave-background.component.html',
  styleUrl: './wave-background.component.scss',
})
export class WaveBackgroundComponent {
  waveService = inject(WaveService);
  constructor() {}
}
